import React from 'react';
import { Select } from 'antd';

export const aSearchElements = [
  {
    label: 'Nombre',
    name: 'description',
    type: 'input',
  },
  {
    label: 'Estatus',
    name: 'status',
    placeholder: 'Todos',
    type: 'select',
    values: () => (
      <>
        <Select.Option value={1}>Activo</Select.Option>
        <Select.Option value={0}>Inactivo</Select.Option>
      </>
    ),
  },
];

export const oInitState = {
  name: '',
  validity: '',
  status: undefined,
};
